export default "__VITE_ASSET__DBsZW_m3__"